import * as Headless from "@headlessui/react";
import * as React from "react";
import { useShouldReload } from "@/app/Meta/utils/useBuildSha";
import { createLink } from "@tanstack/react-router";
import { clsx } from "clsx";

type BasicLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

function BaseModelLinkCell({ className, ...props }: BasicLinkProps) {
  const { handleReloadClick } = useShouldReload();

  return (
    <Headless.DataInteractive>
      <a
        className={clsx("text-blue-500 underline", className)}
        {...props}
        onClick={handleReloadClick(props.onClick)}
      />
    </Headless.DataInteractive>
  );
}

export const ModelLinkCell = createLink(BaseModelLinkCell);
